
import { defineComponent } from 'vue'
import { iFunction, iFunctionType, iDataset } from './FunctionsCatalog'
import { AxiosResponse } from 'axios'
import FunctionsCatalogDatatable from './FunctionsCatalogDatatable.vue'
import FunctionsCatalogDetail from './FunctionsCatalogDetail.vue'
import FunctionsCatalogFilterCards from './FunctionsCatalogFilterCards.vue'
import FunctionsCatalogPreviewDialog from './FunctionsCatalogPreviewDialog/FunctionsCatalogPreviewDialog.vue'
import KnFabButton from '@/components/UI/KnFabButton.vue'

export default defineComponent({
    name: 'functions-catalog',
    components: {
        FunctionsCatalogDatatable,
        FunctionsCatalogDetail,
        FunctionsCatalogFilterCards,
        FunctionsCatalogPreviewDialog,
        KnFabButton
    },
    data() {
        return {
            user: null as any,
            functions: [] as iFunction[],
            selectedFunction: null as iFunction | null,
            filters: [] as iFunctionType[],
            selectedFilter: null as iFunctionType | null,
            datasets: [] as iDataset[],
            detailDialogVisible: false,
            previewDialogVisible: false,
            loading: false
        }
    },
    async created() {
        this.loadUser()
        await this.loadPage()
    },
    methods: {
        async loadUser() {
            this.user = (this.$store.state as any).user
        },
        async loadPage() {
            this.loading = true
            await this.loadFunctions('')
            await this.loadFilters()
            this.loading = false
        },
        async loadFunctions(filterValue: string) {
            const url = filterValue ? process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/functions-catalog/` + filterValue : process.env.VUE_APP_API_PATH + `1.0/functioncatalog/completelist`
            await this.$http.get(url).then((response: AxiosResponse<any>) => {
                this.functions = filterValue
                    ? response.data.functions.map((el: any) => {
                          el.tags = [...el.keywords]
                          el.offlineScriptTrain = { ...el.offlineScriptTrainModel }
                          el.offlineScriptUse = { ...el.offlineScriptUseModel }
                          el.benchmark = { ...el.benchmarks }
                          const props = ['keywords', 'offlineScriptTrainModel', 'offlineScriptUseModel', 'benchmarks']
                          props.forEach((property: string) => delete el[property])
                          return el
                      })
                    : response.data
            })
        },
        async loadFilters() {
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/domains/listByCode/FUNCTION_TYPE`).then((response: AxiosResponse<any>) => (this.filters = response.data))
        },
        showForm(selectedFunction: iFunction | null) {
            this.selectedFunction = selectedFunction
            this.detailDialogVisible = true
        },
        async deleteFunction(functionId: number) {
            this.loading = true
            let reponseOk = false as any
            await this.$http
                .delete(process.env.VUE_APP_API_PATH + `1.0/functioncatalog/${functionId}`)
                .then(() => {
                    reponseOk = true
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                })
                .catch(() => {
                    this.$store.commit('setError', {
                        title: this.$t('common.toast.errorTitle'),
                        msg: this.$t('managers.functionsCatalog.deleteError')
                    })
                })
                .finally(() => (this.loading = false))

            if (reponseOk) {
                await this.loadPage()
            }
        },
        async onSelectedFilter(filter: iFunctionType) {
            if (this.selectedFilter?.valueCd === filter.valueCd) {
                return
            }
            this.selectedFilter = filter
            const filterValue = this.selectedFilter.valueCd !== 'All' ? this.selectedFilter.valueCd : ''
            this.loading = true
            await this.loadFunctions(filterValue)
            this.loading = false
        },
        onDetailClose() {
            this.detailDialogVisible = false
            this.selectedFunction = null
        },
        async onCreated() {
            this.detailDialogVisible = false
            await this.loadPage()
        },
        async onPreview(tempFunction: iFunction) {
            this.selectedFunction = tempFunction
            await this.loadPreviewData()
            this.previewDialogVisible = true
        },
        onPreviewClose() {
            this.previewDialogVisible = false
            this.selectedFunction = null
        },
        async loadPreviewData() {
            this.loading = true
            await this.loadDatasets()
            this.loading = false
        },
        async loadDatasets() {
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `3.0/datasets/`).then((response: AxiosResponse<any>) => (this.datasets = response.data.root))
        }
    }
})
